import { formatFindSlipNumber, type HistoryVersion } from '@ast-data/shared';

/** A Fund's version in the history, named as everywhere else: "123_2". */
export function findHistoryLabel(version: HistoryVersion): string {
    return formatFindSlipNumber({
        findSlipNumber: String(version.findSlipNumber ?? ''),
        subFindSlipNumber: String(version.subFindSlipNumber ?? '')
    });
}
